import iconAlipay from "./images/payment-icons/payment_alipay.svg";
import iconWechat from "./images/payment-icons/payment_wechat.svg";
import iconLinepay from "./images/payment-icons/payment_linepay.svg";
import iconPaypal from "./images/payment-icons/payment_paypal.svg";
import iconCoin from "./images/payment-icons/payment_coin.svg";
import iconCreditcard from "./images/payment-icons/payment_creditcard.svg";
import iconStripe from "./images/payment-icons/payment_stripe.svg";
import iconVisa from "./images/payment-icons/payment_visa.svg";
import iconMacauCreditcard from "./images/payment-icons/payment_macau_creditcard.svg";
import iconPayme from "./images/payment-icons/payment_payme.svg";
import iconMaybank from "./images/payment-icons/payment_maybank.svg";
import iconFpx from "./images/payment-icons/payment_fpx.svg";
import iconNeweb from "./images/payment-icons/payment_neweb.svg";
import iconMycard from "./images/payment-icons/payment_mycard.png";
import iconOctopus from "./images/payment-icons/payment_octopus.png";
import iconPaynow from "./images/payment-icons/payment_paynow.png";
import icon711 from "./images/payment-icons/payment_711.svg";
import iconGooglepay from "./images/payment-icons/payment_googlepay.svg";
import iconShopee from "./images/payment-icons/payment_shopee.svg";
import iconGrabpay from "./images/payment-icons/payment_grabpay.svg";
import iconPxpayplus from "./images/payment-icons/payment_pxpayplus.svg";
import iconTaiwanpay from "./images/payment-icons/payment_taiwanpay.svg";
import iconApplepay from "./images/payment-icons/payment_applepay.svg";
import iconLinkaja from "./images/payment-icons/payment_linkaja.svg";
import iconAtm from "./images/payment-icons/payment_atm.svg";
import iconTruemoney from "./images/payment-icons/payment_truemoney.svg";
import iconCenpay from "./images/payment-icons/payment_cenpay.svg";

const ICON_RULES = [
	{ keys: ["alipay", "支付宝", "alipayhk"], icon: iconAlipay },
	{ keys: ["wechat", "微信", "wechatpay"], icon: iconWechat },
	{ keys: ["linepay", "line pay"], icon: iconLinepay },
	{ keys: ["paypal"], icon: iconPaypal },
	{ keys: ["coin", "点数", "點數", "铜币", "銅幣"], icon: iconCoin },
	{
		keys: ["全球信用卡", "globalcreditcard", "globalcreditcardpayment", "stripe"],
		icon: iconStripe,
	},
	{ keys: ["澳門信用卡", "澳门信用卡", "macaucreditcard"], icon: iconMacauCreditcard },
	{ keys: ["creditcard", "信用卡", "credit card"], icon: iconCreditcard },
	{ keys: ["visa"], icon: iconVisa },
	{ keys: ["payme"], icon: iconPayme },
	{ keys: ["maybank"], icon: iconMaybank },
	{ keys: ["fpx"], icon: iconFpx },
	{ keys: ["newebpay", "neweb", "蓝新", "藍新"], icon: iconNeweb },
	{ keys: ["八达通", "八達通", "octopus"], icon: iconOctopus },
	{ keys: ["paynow"], icon: iconPaynow },
	{ keys: ["7eleven", "711", "seven"], icon: icon711 },
	{ keys: ["googlepay", "google pay"], icon: iconGooglepay },
	{ keys: ["shopee", "shopeepay"], icon: iconShopee },
	{ keys: ["grab", "grabpay"], icon: iconGrabpay },
	{ keys: ["全支付", "pxpayplus", "pxpay"], icon: iconPxpayplus },
	{ keys: ["台湾pay", "台灣pay", "taiwanpay"], icon: iconTaiwanpay },
	{ keys: ["applepay", "apple pay"], icon: iconApplepay },
	{ keys: ["linkaja"], icon: iconLinkaja },
	{ keys: ["atmcard", "atm card"], icon: iconAtm },
	{ keys: ["truemoney"], icon: iconTruemoney },
	{ keys: ["cenpay"], icon: iconCenpay },
];

const normalizeKey = value =>
	String(value || "")
		.toLowerCase()
		.replace(/[\s_\-/（）()]/g, "");

export const resolvePaymentIcon = item => {
	const name = normalizeKey(item?.name);
	const type = normalizeKey(item?.type);
	const apiIcon = item?.icon;

	if (apiIcon) {
		return apiIcon;
	}

	if (name === "mycard") {
		return iconMycard;
	}

	for (const rule of ICON_RULES) {
		if (
			rule.keys.some(key => name.includes(normalizeKey(key)) || type.includes(normalizeKey(key)))
		) {
			return rule.icon;
		}
	}

	return "";
};
